export type PillProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & { children: React.ReactNode }

export const Pill = ({ children, className, ...otherProps }: PillProps) => (
    <span
        className={`ds-u-radius--pill ds-u-color--base my-c-pill ${className ?? ''}`}
        {...otherProps}
    >
        {children}
    </span>
)
